module.exports = __webpack_public_path__ + "img/logo_przedruk@2x-1.d20b709b.png";